module.exports = __webpack_public_path__ + "img/hemline_upper_pocket_position.c5a5d143.png";